export default __webpack_public_path__ + "static/media/infographic-arrow-right.60f915e9.svg";